import { CurrencyCode } from '@src/types/common';

export function getCurrencySymbol(currencyCode?: CurrencyCode): string {
    const symbols: Record<CurrencyCode, string> = {
        USD: '$',
        EUR: '€',
        GBP: '£',
        TRY: '₺',
    };

    const validCurrencyCodes = Object.keys(symbols) as CurrencyCode[];

    const normalized = currencyCode?.toUpperCase() as CurrencyCode;

    if (normalized && validCurrencyCodes.includes(normalized)) {
        return symbols[normalized];
    }

    return symbols.USD;
}

export function fixNumberPrecision(value: number | string | undefined): string {
    if (value === undefined) return '';

    const str = String(value).trim();
    const match = /^(\d+)(\.\d+)?\s?(.*)$/.exec(str);
    if (!match) return str;

    const [, intPart, decimalPart, suffix] = match;

    const num = parseFloat(intPart + (decimalPart ?? ''));

    const formatted = num.toFixed(2).replace(/\.?0+$/, '');

    return suffix ? `${formatted} ${suffix}`.trim() : formatted;
}
